import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  image1: null,
  image2: null,
  image3: null,
  isUploadInProgress: false,
  isCreateIssueInProgress: false,
  isEditIssueInProgress: false,
  isGetIssueInProgress: false,
  isUpdatingStatus: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPLOAD_IMAGE_SUCCESS:
    case actionTypes.DELETE_IMAGE_SUCCESS:
      if (action.payload.type === 'issue') {
        return Object.assign({}, state, {
          [action.payload.key]: action.payload.image,
        });
      } else {
        return state;
      }
    case actionTypes.GET_CROP_ISSUE_SUCCESS:
      return Object.assign({}, state, {
        image1: action.payload.images[0],
        image2: action.payload.images[1],
        image3: action.payload.images[2],
      });
    case '@@redux-form/RESET':
      if (
        action.meta.form === 'addNewIssue' ||
        action.meta.form === 'editCropIssue'
      ) {
        return initialState;
      } else {
        return state;
      }
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.DELETE_IMAGE:
        case 'ALL':
          return Object.assign({}, state, { isUploadInProgress: true });
        case actionTypes.CREATE_ISSUE:
          return Object.assign({}, state, { isCreateIssueInProgress: true });
        case actionTypes.EDIT_CROP_ISSUE:
          return Object.assign({}, state, { isEditIssueInProgress: true });
        case actionTypes.GET_CROP_ISSUE:
          return Object.assign({}, state, { isGetIssueInProgress: true });
        case actionTypes.MARK_CROP_ISSUE:
          return Object.assign({}, state, { isUpdatingStatus: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.DELETE_IMAGE:
        case 'ALL':
          return Object.assign({}, state, { isUploadInProgress: false });
        case actionTypes.CREATE_ISSUE:
          return Object.assign({}, state, { isCreateIssueInProgress: false });
        case actionTypes.EDIT_CROP_ISSUE:
          return Object.assign({}, state, { isEditIssueInProgress: false });
        case actionTypes.GET_CROP_ISSUE:
          return Object.assign({}, state, { isGetIssueInProgress: false });
        case actionTypes.MARK_CROP_ISSUE:
          return Object.assign({}, state, { isUpdatingStatus: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
